/* INVOICE DATA */
export const GET_CONTRACTORS_LIST = "GET_CONTRACTORS_LIST";
export const SET_CONTRACTORS_LIST = "SET_CONTRACTORS_LIST";
export const ADD_CONTRACTOR = "ADD_CONTRACTOR";

/* INVOICE ACTIONS */
export const DELETE_CONTRACTOR = "DELETE_CONTRACTOR";

/* INVOICE DATA PROFILE */
export const GET_CONTRACTOR_PROFILE = "GET_CONTRACTOR_PROFILE";
export const SET_CONTRACTOR_PROFILE = "SET_CONTRACTOR_PROFILE";
export const UPDATE_CONTRACTOR_PROFILE = "UPDATE_CONTRACTOR_PROFILE";
export const SET_ERROR_CONTRACTOR_PROFILE = "SET_ERROR_CONTRACTOR_PROFILE";

/* LOADER */
export const SHOW_CONTRACTOR_LIST_LOADER = "SHOW_CONTRACTOR_LIST_LOADER";
export const HIDE_CONTRACTOR_LIST_LOADER = "HIDE_CONTRACTOR_LIST_LOADER";
export const CONTRACTOR_PROFILE_LOADER = "CONTRACTOR_PROFILE_LOADER";
